import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config';

interface PaymentInitiatePayload {
  user_id: number;
  product_id: number;
  shipping_method_id: number;
  type: string; // 'buying' or 'selling'
}

interface PaymentInitiateResponse {
  clientSecret: string;
  status: string; // e.g. '200 OK'
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private http: HttpClient) {}

  // initiateShipmentPayment(payload: PaymentInitiatePayload): Observable<PaymentInitiateResponse> {
  //   return this.http.post<PaymentInitiateResponse>(`${Config.apiUrl}/shipping/shipment-payment-initiate`, payload);
  // }
//   startMolliePayment(payload: {
//     user_id: number;
//     product_id: number;
//     shipping_method_id: number;
//     // chatId: string;
//     type: string,
//     // amount: number;
//   }): Observable<{
//     redirect_url: any; checkoutUrl: string 
// }> {
//     return this.http.post<{ checkoutUrl: string }>(
//       `${Config.apiUrl}/shipping/shipment-payment-initiate`,
//       payload
//     );
//   }


startMolliePayment(payload: {
  user_id: number;
  product_id: number;
  shipping_method_id: string;
  type: string;
}): Observable<{
  redirect_url: string;
  checkoutUrl?: string;
}> {
  return this.http.post<{
    redirect_url: string;
    checkoutUrl?: string;
  }>(`${Config.apiUrl}/shipping/shipment-payment-initiate`, payload);
}

capturePayment(orderId: string): Observable<{ status: string; message: string; payment_status: string }> {
  return this.http.post<{ status: string; message: string; payment_status:string }>(
    `${Config.apiUrl}/shipping/save-payment-details`,
    { order_id: orderId }
  );
}
}
